import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/base/SEOHead";
import ScrollReveal from "@/components/base/ScrollReveal";

const categories = [
  {
    id: "policy",
    title: "保單門神｜保障健檢與理賠效率",
    desc: "以「缺口先補、架構分層」為原則，醫療、意外、重大傷病、收支與理賠流程一次到位。",
    color: "border-brand-gold/50",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20family%20protection%20scene%20with%20soft%20golden%20lighting%20on%20dark%20background%2C%20silhouette%20of%20mother%20and%20children%20feeling%20safe%20and%20secure%2C%20abstract%20golden%20shield%20glow%20surrounding%20them%2C%20emotional%20and%20trustworthy%20atmosphere%2C%20premium%20insurance%20brand%20testimonial%20aesthetic%2C%20dark%20tones%20with%20gold%20accents%2C%20cinematic%20mood%2C%204K%20quality&width=800&height=300&seq=301&orientation=landscape",
    cards: [
      {
        title: "家庭保障重整，費用下降",
        client: "雙薪家庭・兩孩・年保費 12 萬",
        challenge: "舊約分散、重複給付、保費偏高",
        result: "年保費減少，重大醫療缺口補足",
        quote: "該留的留、該砍的砍，清楚又省。",
      },
      {
        title: "實支實付升級＋理賠教戰手冊",
        client: "護理師・高醫療曝險",
        challenge: "門診自費高、理賠文件常補件",
        result: "理賠流程更順，文件準備更清楚",
        quote: "有 SOP 之後，理賠變得超順。",
      },
      {
        title: "癌症風險專案",
        client: "家族病史・40 歲",
        challenge: "擔心核保與除外條款",
        result: "完成癌症一次金與重大傷病規劃",
        quote: "如實告知，也能找到適合的解法。",
      },
    ],
  },
  {
    id: "asset",
    title: "財產門神｜資產配置與風險控管",
    desc: "把資產分層、把風險量化，降低市場波動對生活與情緒的影響。",
    color: "border-brand-gold/50",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20financial%20planning%20workspace%20with%20golden%20light%20streams%20on%20dark%20background%2C%20abstract%20balanced%20scale%20and%20wealth%20symbols%20glowing%20in%20warm%20gold%2C%20premium%20asset%20management%20aesthetic%2C%20calm%20and%20disciplined%20atmosphere%2C%20dark%20tones%20with%20elegant%20gold%20accents%2C%20cinematic%20mood%2C%204K%20quality&width=800&height=300&seq=302&orientation=landscape",
    cards: [
      {
        title: "投資紀律建立",
        client: "上班族・長期投資",
        challenge: "行情波動時情緒化加碼",
        result: "避免追高殺低，報酬曲線更平順",
        quote: "原來不動，有時就是最好的動作。",
      },
      {
        title: "資金分艙後，現金流更安心",
        client: "新婚家庭",
        challenge: "生活費、保費、投資金混在一起",
        result: "帳戶分層後，家庭支出更清楚",
        quote: "錢放在哪裡，終於看得懂了。",
      },
      {
        title: "資產配置重整",
        client: "中高資產客戶",
        challenge: "資產集中單一工具，波動過大",
        result: "配置更分散，風險更可控",
        quote: "不是只追報酬，而是先守住風險。",
      },
    ],
  },
  {
    id: "enterprise",
    title: "企業門神｜長期傳承與企業防護",
    desc: "以制度為盾，企業保障健診、負責人守護、員工留才與股權傳承，讓企業走得更穩、更久。",
    color: "border-brand-gold/50",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20interior%20with%20golden%20light%20accents%20on%20dark%20background%2C%20abstract%20team%20collaboration%20scene%20with%20flowing%20gold%20connections%2C%20premium%20enterprise%20brand%20aesthetic%2C%20stability%20and%20growth%20atmosphere%2C%20dark%20tones%20with%20warm%20gold%20lighting%2C%20cinematic%20mood%2C%204K%20quality&width=800&height=300&seq=303&orientation=landscape",
    cards: [
      {
        title: "團保升級，留才有感",
        client: "中小企業主",
        challenge: "員工福利不足，留才困難",
        result: "團險制度升級，員工安全感提高",
        quote: "員工感受到公司真的有在照顧他們。",
      },
      {
        title: "薪資與投保制度檢視",
        client: "服務業公司",
        challenge: "薪資結構與投保邏輯不清",
        result: "制度文件化，降低勞資爭議",
        quote: "以前憑經驗，現在有規則。",
      },
      {
        title: "傳承與信託架構",
        client: "傳產二代交接期",
        challenge: "接班權責不清、稅務與資金安排不足",
        result: "交接期平穩，家族共識成形",
        quote: "清楚的規則，讓關係更簡單。",
      },
    ],
  },
  {
    id: "life",
    title: "人生門神｜里程碑與長程規劃",
    desc: "以人生事件為主軸：成家、生子、換屋、創業、退休、傳承——現金流與風險同步規劃。",
    color: "border-brand-gold/50",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20intergenerational%20family%20scene%20with%20golden%20light%20pathways%20on%20dark%20background%2C%20elder%20and%20young%20adult%20hands%20reaching%20together%20symbolizing%20legacy%20and%20inheritance%2C%20abstract%20golden%20tree%20of%20life%20roots%20flowing%20beneath%2C%20premium%20life%20planning%20brand%20aesthetic%2C%20emotional%20and%20hopeful%20atmosphere%2C%20dark%20tones%20with%20warm%20gold%20accents%2C%20cinematic%20mood%2C%204K%20quality&width=800&height=300&seq=304&orientation=landscape",
    cards: [
      {
        title: "教育金規劃",
        client: "雙薪家庭・兩名子女",
        challenge: "不知道教育金到底要準備多少",
        result: "建立分年目標與資金路線圖",
        quote: "孩子的未來，不再只是模糊的擔心。",
      },
      {
        title: "退休現金流重整",
        client: "準退休族",
        challenge: "擔心退休後收入不穩",
        result: "建立必要支出、彈性支出與醫療預備金",
        quote: "退休不是停止收入，而是重新安排現金流。",
      },
      {
        title: "傳承安排",
        client: "高資產家庭",
        challenge: "資產流向、照護責任與家庭情感複雜",
        result: "資產流向清楚，法律與情感都被看見",
        quote: "我想要怎麼被記得，自己決定。",
      },
    ],
  },
];

export default function Testimonials() {
  return (
    <div className="min-h-screen bg-brand-black">
      <SEOHead
        title="客戶見證 | 真實案例與服務成果 | 保險門神"
        description="從保障健檢、資產配置與紀律風控，到企業制度化防線、人生里程碑與傳承設計。真實客戶見證，看得見的守護成果。"
        keywords="客戶見證,保險案例,資產配置成果,企業風險管理案例,保險門神評價"
        canonicalPath="/testimonials"
        ogType="website"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "客戶見證 - 保險門神 Insurance Guardian",
          "description": "從保障健檢、資產配置與紀律風控，到企業制度化防線、人生里程碑與傳承設計。真實客戶見證，看得見的守護成果。",
          "url": "__SITE_URL__/testimonials",
          "isPartOf": {
            "@type": "WebSite",
            "name": "保險門神 Insurance Guardian",
            "url": "__SITE_URL__/"
          }
        }}
      />
      <Header />
      <main>
        {/* Hero */}
        <section className="relative pt-24 md:pt-32 pb-12 md:pb-16 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dark%20luxury%20background%20with%20golden%20glowing%20testimonial%20stars%20and%20review%20symbols%20on%20deep%20black%20canvas%2C%20flowing%20gold%20light%20particles%20forming%20heart%20and%20shield%20shapes%2C%20premium%20customer%20satisfaction%20brand%20aesthetic%2C%20warm%20and%20trustworthy%20atmosphere%2C%20dark%20tones%20with%20elegant%20gold%20accents%2C%20cinematic%20mood%2C%204K%20quality&width=1920&height=600&seq=305&orientation=landscape"
              alt="客戶見證 Hero 背景"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" />
          </div>
          <div className="container-main relative z-10">
            <div className="text-center">
              <div className="inline-block border border-brand-border rounded-full px-5 py-2 mb-6">
                <span className="text-brand-gold text-[1rem] font-medium tracking-wide">
                  客戶見證
                </span>
              </div>
              <h1 className="text-white font-display font-bold text-[2rem] md:text-[2.75rem] leading-[1.3] md:leading-[1.25] mb-4">
                客戶見證｜真實成果，看得見的守護
              </h1>
              <p className="text-brand-text-secondary text-[1.1875rem] leading-[1.75] max-w-[720px] mx-auto">
                從保障健檢、資產配置與紀律風控，到企業制度化防線、人生里程碑與傳承設計；每一份見證，都代表一次安心的開始。
              </p>
              <div className="w-[60px] h-[2px] bg-brand-gold mx-auto mt-4" />
            </div>
          </div>
        </section>

        {/* Categories */}
        {categories.map((cat, catIndex) => (
          <section
            key={cat.id}
            className={`py-16 md:py-20 ${
              cat.id === "asset" || cat.id === "life"
                ? "bg-brand-card border-y border-brand-border"
                : ""
            }`}
          >
            <div className="container-main">
              {/* Category Image Banner */}
              <ScrollReveal delay={catIndex * 80}>
                <div className="relative w-full h-[180px] md:h-[220px] rounded-2xl overflow-hidden mb-10 md:mb-12">
                  <img
                    src={cat.image}
                    alt={cat.title}
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />
                  <div className="absolute inset-0 flex items-center p-6 md:p-8">
                    <div>
                      <h2 className="text-white font-display font-bold text-[1.5rem] md:text-[2rem] leading-[1.4] mb-2">
                        {cat.title}
                      </h2>
                      <p className="text-brand-text-secondary text-[1.0625rem] md:text-[1.1875rem] leading-[1.75] max-w-[560px]">
                        {cat.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollReveal>

              {/* Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {cat.cards.map((card, idx) => (
                  <ScrollReveal key={idx} delay={idx * 120}>
                    <div
                      className={`group bg-brand-black border ${cat.color} rounded-2xl p-6 md:p-7 transition-all duration-300 hover:border-brand-gold flex flex-col h-full`}
                    >
                      {/* Client Avatar / Icon */}
                      <div className="flex items-center gap-3 mb-5">
                        <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-brand-gold/15 border border-brand-gold/40 flex items-center justify-center shrink-0 overflow-hidden">
                          <span className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-brand-gold text-xl">
                            <i className="ri-user-smile-line" />
                          </span>
                        </div>
                        <div>
                          <span className="text-brand-gold text-[0.875rem] md:text-[0.9375rem] font-medium block">
                            {card.client}
                          </span>
                        </div>
                      </div>

                      {/* Title */}
                      <h3 className="text-white font-semibold text-[1.25rem] md:text-[1.5rem] leading-[1.45] mb-4">
                        {card.title}
                      </h3>

                      {/* Challenge */}
                      <div className="mb-3">
                        <span className="text-brand-text-secondary/60 text-[0.875rem] block mb-1">
                          挑戰
                        </span>
                        <p className="text-brand-text-secondary text-[1rem] leading-[1.7]">
                          {card.challenge}
                        </p>
                      </div>

                      {/* Result */}
                      <div className="mb-5">
                        <span className="text-brand-text-secondary/60 text-[0.875rem] block mb-1">
                          成果
                        </span>
                        <p className="text-white text-[1.0625rem] leading-[1.7]">
                          {card.result}
                        </p>
                      </div>

                      {/* Quote */}
                      <div className="mt-auto pt-4 border-t border-brand-border">
                        <div className="flex items-start gap-2">
                          <span className="w-5 h-5 flex items-center justify-center text-brand-gold/60 shrink-0 mt-0.5">
                            <i className="ri-double-quotes-l text-lg" />
                          </span>
                          <p className="text-brand-gold text-[1.0625rem] md:text-[1.1875rem] leading-[1.7] italic">
                            {card.quote}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ScrollReveal>
                ))}
              </div>
            </div>
          </section>
        ))}

        {/* CTA */}
        <section className="py-16 md:py-20">
          <div className="container-main">
            <ScrollReveal>
              <div className="bg-brand-card border border-brand-border rounded-2xl p-8 md:p-14 text-center">
                <h2 className="text-white font-display font-bold text-[1.5rem] md:text-[2.125rem] leading-[1.4] mb-3">
                  想知道你的最佳解？
                </h2>
                <p className="text-brand-text-secondary text-[1.1875rem] leading-[1.75] mb-8 max-w-[640px] mx-auto">
                  30–45 分鐘初談健診，先釐清，再行動：保單門神、財產門神、企業門神、人生門神。
                </p>
                <a
                  href="https://lin.ee/o51JBHX"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-brand-gold text-brand-black px-10 py-4 rounded-full text-[1.125rem] font-semibold hover:bg-brand-gold-soft transition-colors whitespace-nowrap"
                >
                  <i className="ri-line-fill" />
                  預約健診
                </a>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}